import * as React from 'react';
import { graphql, navigate } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/seo';
import { PatchNotePage } from '../components/patch-note-page/patchNotePage';
import { IconButton } from '../components/inputs/icon-button';

const PatchNote = ({ data: { contentfulAppPatchNote }, location }) => {
  const handleBack = () => {
    window.history.back();
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <Layout>
      <SEO
        title={`Patch note ${contentfulAppPatchNote.patchNumber}`}
        description={contentfulAppPatchNote?.patchNotes?.patchNotes}
      />
      {location?.state?.backButton ? (
        <IconButton onClick={handleBack} />
      ) : (
        <IconButton onClick={handleHome} iconName="home" />
      )}
      <PatchNotePage data={contentfulAppPatchNote} />
    </Layout>
  );
};

export const query = graphql`
  query GetPatchNote($patchNumber: String = "5.0.0") {
    contentfulAppPatchNote(patchNumber: { eq: $patchNumber }) {
      patchNumber
      patchDate
      patchNotes {
        patchNotes
        childMarkdownRemark {
          html
        }
      }
      image {
        fluid(maxWidth: 1920) {
          ...GatsbyContentfulFluid
        }
      }
    }
  }
`;

export default PatchNote;
